document.addEventListener('DOMContentLoaded', () => {
    document.querySelector('.scrollToDiv').addEventListener('click', function (e) {
        e.preventDefault();
        console.log('Button clicked');

        // Select the target element
        const targetElement = document.getElementById('scrollto');
        const header = document.querySelector('.headerMain.pageViews_nodes_accessoires__headerMain'); // Select the dynamic header

        if (targetElement) {
            console.log('Target element found:', targetElement);

            // Dynamically get the header height and double it
            const headerHeight = header ? header.offsetHeight * 2.5 : 0; // Double the height or fallback to 0
            const boundingRect = targetElement.getBoundingClientRect();
            let targetPosition = window.scrollY + boundingRect.top - headerHeight;

            // Ensure the scroll position is not negative
            if (targetPosition < 0) {
                targetPosition = 0;
            }

            // Smooth scroll to the calculated position
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth',
            });

            console.log('Bounding Rect:', boundingRect);
            console.log('Dynamic Header height (doubled):', headerHeight);
            console.log('Scrolled to position with offset:', targetPosition);
        } else {
            console.warn('Target element not found!');
        }
    });
});
